import { isElementNode } from 'anodum';
import disable from '../../injections/bindings/disable';
import text from '../../injections/bindings/text';
import isSelectableElement from '../../verifiers/is-selectable-element';

const isLinkInsideText = (node) => node.matches(`[${text.TEXT_ATTRIBUTE}] a.ws-link`);

const getClosestSelectableElement = (element) => {
  let targetElement = element;

  while (targetElement) {
    if (
      !isLinkInsideText(targetElement) &&
      isElementNode(targetElement) &&
      !disable.isDisabledNode(targetElement) &&
      isSelectableElement(targetElement)
    ) {
      return targetElement;
    }

    const { parentElement } = targetElement;
    targetElement = parentElement;
  }

  return null;
};

export default getClosestSelectableElement;
